/**
 * Multi-tenant helpers: resolve current tenant and scope storage keys.
 * Priority: VUE_APP_TENANT_CODE → subdomain → root label → "default"
 * Cách hoạt động

  Resolve tenant: VUE_APP_TENANT_CODE → subdomain → label host → default
  Cookie/localStorage: {tenant}:{key} (vd. kimahome:81198012409372729)
  Vuex: tenantCode + companyByTenant[tenant]
  Có fallback migrate key cũ → key scoped
  Request gắn header X-Tenant-Code

 */


const TENANT_RE = /^[a-z0-9][a-z0-9_-]{0,63}$/

export const DEFAULT_TENANT_CODE = 'default'

const normalizeTenantCode = (value?: string | null): string => {
  if (!value) return DEFAULT_TENANT_CODE
  const code = String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
  return TENANT_RE.test(code) ? code : DEFAULT_TENANT_CODE
}

export const resolveTenantCode = (hostname = typeof window !== 'undefined' ? window.location.hostname : ''): string => {
  const envCode = process.env.VUE_APP_TENANT_CODE
  if (envCode) return normalizeTenantCode(envCode)

  const host = String(hostname || '')
    .toLowerCase()
    .replace(/\.$/, '')
    .replace(/^www\./, '')

  if (!host || host === 'localhost' || host.endsWith('.localhost') || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return DEFAULT_TENANT_CODE
  }

  const parts = host.split('.').filter(Boolean)
  // brand.domain.tld → brand; brand.tld → brand
  if (parts.length >= 2) return normalizeTenantCode(parts[0])
  return DEFAULT_TENANT_CODE
}

/** Scope cookie / localStorage key by tenant: `{tenant}:{baseKey}` */
export const tenantStorageKey = (baseKey: string, tenantCode = resolveTenantCode()): string => {
  const base = String(baseKey || '').trim()
  const tenant = normalizeTenantCode(tenantCode)
  if (!base) return tenant
  if (base.startsWith(`${tenant}:`)) return base
  return `${tenant}:${base}`
}

export const getTenantCode = (): string => resolveTenantCode()
